import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/PieChart/utils"
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.PENDING_MENTORING_REQUESTS]: "#F76B15",
  [MetricUId.ACCEPTED_MENTORING_REQUESTS]: "#0969DA",
  [MetricUId.WITHDRAWN_MENTORING_REQUESTS]: "#D0D6DB",
  [MetricUId.REJECTED_MENTORING_REQUESTS]: "#E54D2E",
  [MetricUId.CLOSED_MENTORING_REQUESTS]: "#8E4EC6"
}

export const chartOnlyMetrics = [MetricUId.PENDING_MENTORING_REQUESTS, MetricUId.ACCEPTED_MENTORING_REQUESTS, MetricUId.WITHDRAWN_MENTORING_REQUESTS, MetricUId.REJECTED_MENTORING_REQUESTS, MetricUId.CLOSED_MENTORING_REQUESTS, MetricUId.TOTAL_MENTORING_REQUESTS]

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.PENDING_MENTORING_REQUESTS, MetricUId.ACCEPTED_MENTORING_REQUESTS, MetricUId.WITHDRAWN_MENTORING_REQUESTS, MetricUId.REJECTED_MENTORING_REQUESTS, MetricUId.CLOSED_MENTORING_REQUESTS],
    subTitleMetricUid: MetricUId.TOTAL_MENTORING_REQUESTS,
    exportFileName: props.name,
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;